import { render, staticRenderFns } from "./PlanFeatureHoverCard.vue?vue&type=template&id=0ed272f4&scoped=true"
import script from "./PlanFeatureHoverCard.vue?vue&type=script&lang=js"
export * from "./PlanFeatureHoverCard.vue?vue&type=script&lang=js"
import style0 from "./PlanFeatureHoverCard.vue?vue&type=style&index=0&id=0ed272f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed272f4",
  null
  
)

export default component.exports